import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface FilterBarProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  filters: { label: string; value: string; count?: number }[];
  activeFilter: string;
  onChange: (value: string) => void;
}

export const FilterBar = forwardRef<HTMLDivElement, FilterBarProps>(
  ({ filters, activeFilter, onChange, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn("flex w-full overflow-x-auto hide-scrollbar items-center gap-2 py-2", className)}
        {...props}
      >
        {filters.map((filter) => {
          const isActive = activeFilter === filter.value;

          return (
            <button
              key={filter.value}
              onClick={() => onChange(filter.value)}
              className={cn(
                "inline-flex whitespace-nowrap items-center justify-center rounded-full px-4 py-1.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                isActive
                  ? "bg-primary text-primary-foreground shadow-sm"
                  : "bg-muted/50 text-muted-foreground hover:bg-muted"
              )}
            >
              {filter.label}
              {filter.count !== undefined && (
                <span
                  className={cn(
                    "ml-2 inline-flex items-center justify-center rounded-full px-1.5 py-0.5 text-xs font-semibold",
                    isActive ? "bg-primary-foreground/20 text-primary-foreground" : "bg-background text-muted-foreground"
                  )}
                >
                  {filter.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
    );
  }
);
FilterBar.displayName = "FilterBar";
